<template>
  <v-footer :style="getVaquejadasLength === 0 ? 'margin-top: 240px' : ''" color="primary" style="display: flex; flex-direction: column">
    <div :style="isMobile ? 'text-align: center; width: 95%' : 'width: 75%; margin: auto'">
      <v-row no-gutters v-if="!isMobile">
        <v-col :style="isMobile ? 'margin-bottom: 10px' : ''" cols="12" md="4" style="display: flex; flex-direction: row; align-items: center; justify-content: center">
          <img src="@/assets/logo-sem-nome.png" alt="logo" style="width: 70px; cursor: pointer;" @click="$router.push('/')">
          <h3 style="cursor: pointer" @click="$router.push('/')">AF Secretaria</h3>
        </v-col>
        <v-col :style="isMobile ? 'margin-bottom: 10px' : ''" cols="12" md="4" class="d-flex flex-column" style="justify-content: center">
          <div style="width: fit-content; margin: auto" class="links-footer">
            <span>Links Rápidos</span>
            <h6 @click="$router.push('/')">Home</h6>
            <h6 @click="$router.push('/validar-senha')">Minha Senha</h6>
            <h6>Sobre Nós</h6>
            <h6 @click="$router.push('/login')">Login</h6>
            <h6 @click="$router.push('/politica-de-privacidade')">Política de Privacidade</h6>
          </div>
        </v-col>
        <v-col cols="12" md="4" :style="isMobile ? 'margin-bottom: 10px' : ''">
          <div style="width: fit-content; margin: auto">
            <span>Contato</span>
            <h6>Email: afsecretaria@gmail.com</h6>
            <h6>Telefone: <span @click="openWhatsapp" style="cursor: pointer" class="hover-link-h6">(88) 9 9657-9226</span></h6>
          </div>
        </v-col>
      </v-row>
      <div v-else style="width: 100%">
        <div style="width: 100%; margin-bottom: 10px; display: flex; flex-direction: row; align-items: center; justify-content: center">
          <img src="@/assets/logo-sem-nome.png" alt="logo" style="width: 70px; cursor: pointer;" @click="$router.push('/')">
          <h3 style="cursor: pointer" @click="$router.push('/')">AF Secretaria</h3>
        </div>
        <div style="width: 100%; flex-direction: row; display: flex; margin-bottom: 10px">
          <div style="width: 55%">
            <div style="width: fit-content; margin: auto">
              <span>Contato</span>
              <h6>Email: afsecretaria@gmail.com</h6>
              <h6>Telefone: <span @click="openWhatsapp" style="cursor: pointer" class="hover-link-h6">(88) 9 9657-9226</span></h6>
            </div>
          </div>
          <div style="width: 45%; border-left: 1px solid white">
            <div style="width: fit-content; margin: auto" class="links-footer">
              <span>Links Rápidos</span>
              <h6 @click="$router.push('/')">Home</h6>
              <h6 @click="$router.push('/validar-senha')">Minha Senha</h6>
              <h6>Sobre Nós</h6>
              <h6 @click="$router.push('/login')">Login</h6>
              <h6 @click="$router.push('/politica-de-privacidade')">Política de Privacidade</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; text-align: center; padding: 10px; font-size: 12px; color: white; border-top: 1px solid #ffffff; margin-top: 10px">
      &copy; {{ new Date().getFullYear() }} <strong>AF Secretaria</strong> — Todos os direitos reservados.
    </div>
  </v-footer>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'FooterComponent',
    computed: {
      isMobile() {
        return this.$vuetify.display.mobile;
      },
      getVaquejadasLength() {
        return this.$store.getVaquejadasLength;
      },
    },
    methods: {
      openWhatsapp() {
        const numero = '5588996579226';
        const url = `https://api.whatsapp.com/send?phone=${numero}`;
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    }
  })
</script>

<style scoped>
.links-footer h6 {
  width: fit-content;
  cursor: pointer !important;
}

.links-footer h6:hover {
  text-decoration: underline;
}

.hover-link-h6:hover {
  text-decoration: underline;
}
</style>
